import { render } from "./FacebookServiceParameter.vue?vue&type=template&id=0268a1c8"
import script from "./FacebookServiceParameter.vue?vue&type=script&lang=ts"
export * from "./FacebookServiceParameter.vue?vue&type=script&lang=ts"
script.render = render

export default script